import React from 'react';
import { datejs } from '@block/utils';
import { Upload, Button, Icon, notification } from '@block/plug';
import classnames from 'classnames';
import Img from './imgs/index';
import Result from './result';
import FileList from '../FileList';
import './index.scss';

const photoCaption = {
  11: ['四角完整', '亮度均匀', '图片清晰'],
  12: ['四角完整', '亮度均匀', '图片清晰'],
  25: ['正面上传', '内容清晰', '亮度均匀'],
};
// 不进行识别的图片类型id
const noOcrType = ['12', '25'];

const { helper } = Upload;

interface Props extends DefaultToFormItem {
  value?: string;
  onChange?: (e: any) => void;
  parent?: any;

  model?: {
    show: boolean;
  };
  label: string;
  fileType?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  url?: string;
}

interface State {
  uploadDialog: {
    type: string; // before未上传前展示示例，after上传后展示识别结果，loading上传中。
    isShow: boolean;
    ocrData: any;
    loading: boolean;
  };
  value: string; // 图片url
  required: boolean;
  fileType: string; // 标识是哪个文件，确定接口，如：身份证正为'11',身份证背面为'12',离职证明为’25‘;
  fileUrl?: any;
}
// 上传文件通过ocr识别信息的组件：用于身份证正面、身份证反面（不识别内容只展示示例）、离职证明上传。
class OcrUpload extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      uploadDialog: {
        type: 'before', // before未上传前展示示例，after上传后展示识别结果，loading上传中。
        isShow: false,
        ocrData: null,
        loading: false,
      },
      value: null, // 图片url
      required: true,
      fileType: props.fileType, // 标识是哪个文件，确定接口，如：身份证正为'11',身份证背面为'12',离职证明为’25‘;
    };
  }

  formRef: React.RefObject<any>;

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    const { value: propsValue } = this.props;
    if (value !== propsValue) {
      this.setState({
        value,
      });
    }
  }

  // 点击上传图片，弹框展示上传示例图
  handleOpen = () => {
    const { uploadDialog } = this.state;
    uploadDialog.type = 'before';
    uploadDialog.loading = false;
    uploadDialog.isShow = true;
    this.setState({ uploadDialog });
  };

  // 关闭弹框
  handleClose = () => {
    const { uploadDialog } = this.state;
    uploadDialog.type = 'before';
    uploadDialog.isShow = false;
    this.setState({ uploadDialog });
  };

  handleChange = (type, loading) => {
    const { uploadDialog } = this.state;
    uploadDialog.type = type;
    uploadDialog.loading = loading;
    this.setState({ uploadDialog });
  };

  // 上传图片
  handleUpload = async (file) => {
    const { uploadDialog } = this.state;
    if (file.size > 10240000) {
      notification.error({ title: '文件不能大于10M' });
      return;
    }
    const fName = file.name.split('.');
    const fType = fName[fName.length - 1].toLowerCase();
    const limitTypes = ['png', 'jpg', 'jpeg', 'bmp'];
    if (!limitTypes.includes(fType)) {
      notification.error({
        message: `上传文件只支持${limitTypes.join('、')}格式`,
      });
      return;
    }
    const { fileType } = this.state;
    if (noOcrType.includes(fileType)) {
      this.handleChange('before', true);
    }
    // } else {
    //   this.handleChange('after', true);
    // }

    helper.upload(`/api/candidate/attachment/ocrUpLoad/${fileType}`, file, {
      params: {},
      onSuccess: (res) => {
        const { fileUrl } = res.fileInfo || {};
        const { onChange } = this.props;
        onChange?.(res.fileInfo || {});
        // 识别成功显示识别结果，识别失败关闭窗口。身份证反面不是识别
        if (res.ocrState === 'success' && !noOcrType.includes(fileType)) {
          this.handleChange('after', true);
          uploadDialog.ocrData = res.ocrData || {};
          if (fileType === '11') {
            uploadDialog.ocrData.nationalityDictIndex = 'CHN';
            uploadDialog.ocrData.nationalityDictName = '中国';
            const { birthday } = uploadDialog.ocrData;
            if (birthday) {
              uploadDialog.ocrData.birthday = parseInt(birthday, 10);
              uploadDialog.ocrData.birthdayStr = datejs(uploadDialog.ocrData.birthday).format('YYYY-MM-DD');
            }
          }
          uploadDialog.type = 'after';
          uploadDialog.loading = false;
          this.setState({
            value: fileUrl,
            // fileTypeName: res.fileInfo && res.fileInfo.fileName,
            uploadDialog,
          });
        } else {
          this.handleClose();
          this.setState({ value: fileUrl }); // fileTypeName: res.fileInfo && res.fileInfo.fileName
        }
      },
      onError: (err) => {
        notification.error({
          message: err.message || '上传失败',
        });
      },
    });
  };

  handleSubmit = (data) => {
    this.handleClose();
    this.props?.parent?.current?.setFieldsValue(data);
  };

  // 校验
  validate = () => {
    const { required, fileUrl } = this.state;
    if (this.props.model.show === false) {
      return true;
    }
    if (!required) {
      return true;
    }
    if (fileUrl) {
      return true;
    }
    return false;
  };

  handleRemove = () => {
    this.setState({
      value: null,
    });
    const { onChange } = this.props;
    onChange && onChange({});
  };

  render() {
    const { uploadDialog, fileType, value } = this.state;
    const { label } = this.props;
    // if (fileData.show === false) {
    //   return null;
    // }

    // if (fileData.mode === 'view' && fileData.required === false && !fileData.fileUrl) {
    //   return null;
    // }
    // pdf图片类型时展示pdf图标。
    // let fileName = fileData && fileData.fileName && fileData.fileName.split('.');

    // if (fileTypeName) {
    //   fileName = fileTypeName && fileTypeName.split('.');
    // }
    // if (fileName && fileName[fileName.length - 1].toLowerCase() === 'pdf') {
    //   fileUrl = Img.pdf;
    // }
    // {fileData.mode && fileData.fileUrl && fileData.mode !== 'view' && (
    //         <div className="icon-content">
    //           <Button
    //             style={{ marginLeft: '8px' }}
    //             className="op-btn"
    //             icon="upload"
    //             onClick={this.handleOpen}
    //           />
    //           <Button
    //             className="op-btn"
    //             icon="trash-o"
    //             onClick={this.deleteImg}
    //           />
    //         </div>
    //         )}
    // <div className="trainee"></div>
    // <div className={valid ? 'one-content ' : 'one-content has-error'}></div>
    return (
      <div className="ocr">
        {value && (
          <div className="ocr__content">
            <FileList url={value} onRemove={this.handleRemove} />
          </div>
        )}
        {!value && (
          <div className="ocr__content" onClick={this.handleOpen}>
            <div className="trainee__text">
              <Icon type="add" />
              <div>{label}</div>
            </div>
          </div>
        )}

        {
          // 弹窗内容
          uploadDialog?.isShow && (
            <div className="dialog">
              <div
                className={classnames(
                  uploadDialog && uploadDialog.type === 'before' ? 'dialog__wrapper' : 'dialog__form',
                )}
              >
                <div className="dialog__title">
                  {uploadDialog.type === 'after' ? '信息核查' : '上传示例'}
                  <span className="dialog__close" onClick={this.handleClose}>
                    <Icon type="close" />
                  </span>
                </div>
                <div className="dialog__content">
                  {uploadDialog && uploadDialog.type === 'before' && (
                    <div className="photo">
                      <div className="photo__top">
                        <img className="photo__right" src={Img[`right${fileType}`]} alt="" />
                        <ul>
                          {photoCaption[fileType]?.map((i, k) => (
                            <li key={k}>{i}</li>
                          ))}
                        </ul>
                      </div>
                      <div className="photo__center">
                        <img className="photo__fault" src={Img[`fault${fileType}`]} alt="" />
                      </div>
                      <div className="photo__bottom">
                        <Button onClick={this.handleClose}>取消</Button>
                        {/* @ts-expect-error */}
                        <Upload type="primary" multiple={false} onUpload={this.handleUpload}>
                          <Button type="primary">继续上传</Button>
                        </Upload>
                      </div>
                    </div>
                  )}
                  {uploadDialog && uploadDialog.type !== 'before' && (
                    <Result
                      ref={this.formRef}
                      data={uploadDialog.ocrData}
                      onSubmit={this.handleSubmit}
                      onClose={this.handleClose}
                    />
                  )}
                </div>
              </div>
            </div>
          )
        }
      </div>
    );
  }
}

export default OcrUpload;
